import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}
export const EmailIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 24 24'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M4.7999 6.59999C4.4624 6.59999 4.1999 6.89999 4.1999 7.19999V8.06249L10.6499 13.35C11.4374 13.9875 12.5249 13.9875 13.3124 13.35L19.7999 8.06249V7.19999C19.7999 6.89999 19.4999 6.59999 19.1999 6.59999H4.7999ZM4.1999 10.3875V16.8C4.1999 17.1375 4.4624 17.4 4.7999 17.4H19.1999C19.4999 17.4 19.7999 17.1375 19.7999 16.8V10.3875L14.4749 14.7375C13.0124 15.9375 10.9499 15.9375 9.5249 14.7375L4.1999 10.3875ZM2.3999 7.19999C2.3999 5.88749 3.4499 4.79999 4.7999 4.79999H19.1999C20.5124 4.79999 21.5999 5.88749 21.5999 7.19999V16.8C21.5999 18.15 20.5124 19.2 19.1999 19.2H4.7999C3.4499 19.2 2.3999 18.15 2.3999 16.8V7.19999Z'
        }
        fill={'#262626'}
      />
    </svg>
  )
}
